module.exports = __webpack_public_path__ + "static/img/banner.b9e3946.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/banner.jpg
// module id = SNO2
// module chunks = 1